import { api } from '@/lib/api';
import { captureSession } from '@/lib/session-snapshot';
import { sessionPermit } from '@/lib/session-permit';
import type { User } from '@valiosascrm/shared';
import type { SessionOwner } from '@/stores/sessionRecovery';

/** Only the cookie coordinator uses these exact, snapshot-bound auth operations. */
export function cookieSessionTransport() {
  const assertCurrent = captureSession();
  return {
    assertCurrent,
    profile: () => api.get<User>('/auth/me', sessionPermit('/auth/me', null, assertCurrent)),
    socket: (owner: SessionOwner) => api.post<{ token: string }>('/auth/socket-token', undefined,
      sessionPermit('/auth/socket-token', `${owner.id}:${owner.tenantId}`, assertCurrent)),
    restore: (observed: SessionOwner, tenantId: string) => api.post('/auth/switch-clinic', { tenantId },
      sessionPermit('/auth/switch-clinic', `${observed.id}:${observed.tenantId}`, assertCurrent)),
  };
}
